import React, { Component } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Routes from './Routes';

//import { withRouter } from "react-router";

class App extends Component {

	//componentDidUpdate(prevProps) {
		//if (this.props.location.pathname !== prevProps.location.pathname) {
			//console.log("route changed");
		//}
	//}

	render() {
		return (
			<React.Fragment>
				<Routes />
			</React.Fragment>
		);
	}
}

//export default withRouter(App);
export default App;